// extracted by mini-css-extract-plugin
module.exports = {"courses":"RelatedJobCourses_courses__6_E_P"};